import TbxComponent from "tbxjs/component";

export class AddBlockBtn extends TbxComponent {
    init() {
        this.requireComponents({'modal': 'document@#tbxAddBlockModal'})
        this.on('click', (e) => { this.modal.show(this.block) });
    }


}